import * as actionsImport from './identity.actions';
import * as reducersImport from './identity.reducers';
import * as selectorsImport from './selectors/index';
import * as typesImport from './identity.types';

export const actions = actionsImport;
export const reducers = reducersImport;
export const selectors = selectorsImport;
export const types = typesImport;
